import React from "react";
import { Navbar as BootstrapNavbar, Nav, Container, Button } from "react-bootstrap";
import "./Navbar.css";
const CustomNavbar = () => {
  return (
    <BootstrapNavbar expand="lg" className="navbar-custom">
      <Container>
        {/* Branding / Logo */}
        <BootstrapNavbar.Brand href="#" className="fw-bold text-primary">
          Pohlert Steinreinigung
        </BootstrapNavbar.Brand>

        {/* Toggle für Mobilgeräte */}
        <BootstrapNavbar.Toggle aria-controls="navbar-nav" />
        <BootstrapNavbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/" className="nav-link-custom">Home</Nav.Link>
            
            <Nav.Link href="#contact" className="nav-link-custom">Kontakt</Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default CustomNavbar;
